export default "__VITE_ASSET__0a3GJFM7__"